export default (lang: string) => {
  const errorMessages = {
    ru: 'E-mail указан неверно',
    uz: "Elektron pochta noto'g'ri ko'rsatilgan",
    kk: 'E-mail қате көрсетілген',
  };

  return errorMessages[lang];
};
